import { render, staticRenderFns } from "./ProductCustomOptions.vue?vue&type=template&id=bc2109a2&scoped=true&"
import script from "./ProductCustomOptions.vue?vue&type=script&lang=js&"
export * from "./ProductCustomOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomOptions.vue?vue&type=style&index=0&id=bc2109a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2109a2",
  null
  
)

export default component.exports